import { useNavigation } from 'react-router-dom'

/**
 * True from the moment a form submits until the screen it leads to has
 * rendered. `navigation.state === 'submitting'` alone drops back to false
 * while a redirect's target loads, which re-enables the button and stops
 * its spinner with the old screen still up.
 */
export function useSubmitBusy(actionPath?: string): boolean {
    const navigation = useNavigation()
    if (navigation.state === 'idle' || navigation.formData == null) {
        return false
    }
    return !actionPath || !!navigation.formAction?.endsWith(actionPath)
}
